export default {"src":"/_next/static/media/hns.b7bb4633.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};